import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

function ChipSatge(props) {

  let literal = props.stage;

  const chipColor = () => {

    if (props.estado){
      if (
        props.estado.includes('No está pagando') || 
        props.estado.includes('En negociación legal') 
      ) {
        return { color: '#D3175C', background: '#fceefe' };
      }

      if (
        props.estado.includes('desaparecido') || 
        props.estado.includes('desestimento')
      ) {
        return { color: '#175CD3', background: '#EFF8FF' };
      }

      if (
        props.estado.includes('Pagando alquiler') || 
        props.estado.includes('Propiedad comprada') || 
        props.estado.includes('OC - En curso') 
      ) {
        return { color: '#067647', background: '#ECFDF3' };
      }
    }

    switch (props.stage) {
      case 'En proceso':
        return { color: '#175CD3', background: '#EFF8FF' };
      case 'Comprado y en alquiler':
        return { color: '#067647', background: '#ECFDF3' };
      case 'Comprado y en venta':
        return { color: '#b512cd', background: '#fceefe' };
      default:
        return { color: '#717171', background: '#F5F5F5' };
    }

  }
  // Si se recibe el estado usarlo en lugar de stage
  if (props.estado) {
    literal = props.estado;
  }

  const colorStyle = chipColor();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px',
      borderRadius: '16px',
      maxWidth: 200,
      color: colorStyle.color,
      backgroundColor: colorStyle.background,
      fontWeight: 'normal',
      fontSize: '13px',
      margin: '4px',
    }}>
      {props.Tipo_Producto + " • " + literal}
      {props.Detalle_estado && props.Detalle_estado.trim() !== '' && (
        <Tooltip title={props.Detalle_estado}>
          <InfoOutlined sx={{ fontSize: 14, mr: 0.5 }} />
        </Tooltip>
      )}
    </div>
  );
};

export default ChipSatge;